angular.
module("tools").
filter("truncate", function truncateDirective() {
	"use strict";

	return function truncate(input, length) {
		if (typeof length === "undefined") {
			throw new Error("Error in angular module 'tools' in filter 'truncate': length can not be undefined.");
		}

		if (input.length > length - 3) {
			input = input.slice(0, length - 3) + "..."; // eslint-disable-line no-param-reassign
		}

		return input;
	};
});
